/**
 * Cookie Consent Banner - 底部弹出横幅
 */

import React from 'react';
import { useCmp } from '../../stores/CmpContext';
import s from './cookieBanner.module.scss';
import Link from 'next/link';

export default function CookieBanner() {
  const { showBanner, acceptAll, acceptEssentials, openSettings } = useCmp();

  if (!showBanner) return null;

  return (
    <div className={s.overlay}>
      <div className={s.banner}>
        <div className={s.content}>
          <div className={s.title}>We value your privacy</div>
          <div className={s.desc}>
            We use cookies to enhance your browsing experience, serve personalized ads or content,
            and analyze our traffic. By clicking "Accept All", you consent to our use of cookies.
            Read our{' '}
            <Link href="/cookie-policy" target="_blank" className={s.link}>
              Cookie Policy
            </Link>{' '}
            to learn more.
          </div>
        </div>
        <div className={s.actions}>
          <button type="button" className={s.btnPrimary} onClick={acceptAll}>
            Accept All
          </button>
          <button type="button" className={s.btnSecondary} onClick={acceptEssentials}>
            Accept Essentials
          </button>
          <button type="button" className={s.btnText} onClick={openSettings}>
            Manage Settings
          </button>
        </div>
      </div>
    </div>
  );
}

